export const billingDetailsEsLocale = {
  'checkout.billingDetails.title': 'Detalles de facturación',
  'checkout.billingDetails.fullName': 'Nombre completo',
  'checkout.billingDetails.documentType': 'Tipo de documento',
  'checkout.billingDetails.documentNumber': 'Número de documento',
  'checkout.billingDetails.phone': 'Teléfono',
  'checkout.billingDetails.email': 'Correo electrónico',
  'checkout.billingDetails.state': 'Departamento',
  'checkout.billingDetails.city': 'Ciudad',
  'checkout.billingDetails.address': 'Dirección',
} as const;

export const billingDetailsEnLocale = {
  'checkout.billingDetails.title': 'Billing details',
  'checkout.billingDetails.fullName': 'Full Name',
  'checkout.billingDetails.documentType': 'Document Type',
  'checkout.billingDetails.documentNumber': 'Document Number',
  'checkout.billingDetails.phone': 'Phone',
  'checkout.billingDetails.email': 'Email',
  'checkout.billingDetails.state': 'State',
  'checkout.billingDetails.city': 'City',
  'checkout.billingDetails.address': 'Address',
} as const;
